import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { internalLayersKeys } from './queryKeys';
import type { InternalLayer, LayerGrant } from 'hooks/internalLayer/types';
import { layerNodesKeys } from 'hooks/layerNode/queryKeys';

export function usePublishInternalLayerMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    InternalLayer,
    unknown,
    { internalLayerId: string; grants?: LayerGrant[] }
  >({
    mutationFn: async ({ internalLayerId, grants }) => {
      const resp = await axios.post<InternalLayer>(
        `${config.apiGateway.internal_layers}/${internalLayerId}/publish`,
        grants?.length ? { grants } : {}
      );
      return resp.data;
    },
    onSuccess: (_layer, variables) => {
      toast.success(
        variables.grants?.length
          ? 'Layer published to the organization.'
          : 'Layer published.'
      );
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: internalLayersKeys.all() });
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
  });
}
